import logoBlack from "../assets/logoBlack.svg";
import SearchBarResultsPage from "./SearchBarResultsPage";
import { useState } from "react";

export default function HeaderNoNav() {
    const [show, setShow] = useState(false);

    const onClick = () => {
        setShow(!show);
    }

    const smallSearch = () => {
        if (!show) {
            return (
                <div>
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" 
                        aria-controls="navbarSupportedContent" aria-expanded={show} aria-label="Toggle navigation" onClick={onClick}>
                            <span className="navbar-toggler-icon"></span>
                    </button>
                    <span>
                        <div className={`${show ? "" : "collapse"} navbar-collapse align-items-end py-3`}>
                            <SearchBarResultsPage show={show} setShow={setShow}/>
                        </div>
                    </span>
                </div>
            )
        } else {
            return (
                <div>
                    <div className={`${show ? "d-grid" : ""}`}>
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" 
                        aria-controls="navbarSupportedContent" aria-expanded={show} aria-label="Toggle navigation" onClick={onClick}>
                            <span className="navbar-toggler-icon"></span>
                    </button>
                    </div>
                    <div className="row justify-content-center">
                        <div className={`${show ? "" : "collapse"} navbar-collapse align-items-end py-3`}>
                            <SearchBarResultsPage show={show} setShow={setShow}/>
                        </div>
                    </div>
                </div>
            )
        }
    }

    return (
        <div>
            <nav className="navbar navbar-expand-sm border-body" data-bs-theme="light">
                <div className="container">
                    <a className="navbar-brand" href="/">
                        <img src={logoBlack} alt="Logo" className="d-inline-block align-text-top"/>
                    </a>
                    {smallSearch()}
                </div>
            </nav>
        </div>
    );
}
